export enum NotificationTypes {
  Export = "EXPORT",
  Import = "IMPORT",
  Report = "REPORT",
  Custom = "CUSTOM",
}
